export default "__VITE_ASSET__Jvfbr805__"